import { string, object } from 'yup'
import { validateMessage } from '~/constants/validation-message'

export const resetPasswordSchema = object({
  password: string()
    .required(' ')
    .matches(/^\S*$/, validateMessage.noWhitespacePassword)
    .min(6, ({ min }) => validateMessage.minPassword(min)),
  confirmPassword: string()
    .required(' ')
    .min(6, ({ min }) => validateMessage.minPassword(min))
    .test(
      'password-match',
      validateMessage.passwordNotMatch,
      (value, { parent }) => {
        return !!value && value === parent.password
      },
    ),
})
